import RefreshSharpIcon from "@mui/icons-material/RefreshSharp";

import { PrimaryButton } from "@/Components/v2/atoms/Button";
import { Typography } from "@/Components/v2/atoms/Typography";
import FullScreenCentered from "@/Components/v2/template/FullScreenCentered";
import { useLogout } from "@/hooks/useLogout";

const NoCustomerDataPage = () => {
  const { logout } = useLogout();

  return (
    <FullScreenCentered>
      <Typography fontWeight={600} variant="h4">
        No Data Available
      </Typography>
      <Typography maxWidth={"490px"} textAlign="center">
        {"It looks like you don't have any data available. Please logout and try again."}
      </Typography>

      <PrimaryButton startIcon={<RefreshSharpIcon />} onClick={logout}>
        Logout
      </PrimaryButton>
    </FullScreenCentered>
  );
};

export default NoCustomerDataPage;
